import script from "./NavigationBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationBlock.vue?vue&type=script&setup=true&lang=js"

import "./NavigationBlock.vue?vue&type=style&index=0&id=20afb06a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20afb06a"]])

export default __exports__